/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";


// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    cssStyling = "cssStyling",
}

// these are the props for the component, aka the predefined arguments defined for the class
interface OwnProps extends WidgetProps {
    fields: {
        [fields.cssStyling]: string;
    };
    extendedStyles?: ComponentStyles;
    history: History;
}

export interface ComponentStyles {
    componentWrapper?: InjectableCss;
}

const mapStateToProps = () => {
    const pageLink =  "/";
    return {  pageLink };
};


const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const CssLoader: React.FunctionComponent<Props> = ({
    // external props like the cardLink for example, need to be mapped to the internal state via mapStateToProps
    // cardLink,
     fields,
     history    }: Props) => {

    return <div>
        <style>{fields.cssStyling}</style>
    </div>;
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.cssStyling,
            displayName: "CSS Styling",
            editorTemplate: "MultilineTextField", // this references the ContentItemFields .tsx files
            defaultValue: "",
            fieldType: "General",
            tooltip: "The css styling for the component",
            placeholder: "Enter css styling",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(CssLoader)),
    definition,
};

export default widgetModule;
